import { render, staticRenderFns } from "./base-file-upload.vue?vue&type=template&id=67d06cca&scoped=true"
import script from "./base-file-upload.vue?vue&type=script&lang=js"
export * from "./base-file-upload.vue?vue&type=script&lang=js"
import style0 from "./base-file-upload.vue?vue&type=style&index=0&id=67d06cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d06cca",
  null
  
)

export default component.exports